<template>
    <admin-layout>

        <app-content-pane class="ml-3">
            <template #title>
                <div class="px-4 pt-3">
                    <h1 v-if="organization">{{ organization.name }}</h1>
                    <h1 v-else>Organizational Report</h1>
                    <nav>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><inertia-link :href="route('project.dashboard', {...global_url_params})">Dashboard</inertia-link></li>
                            <li class="breadcrumb-item active">Organizational Report</li>
                            <li v-if="organization" class="breadcrumb-item active">
                                {{ organization.name }}
                            </li>
                        </ol>
                    </nav>
                </div>
                <hr class="mb-0">
                <div class="actions px-4 pt-3">
                    <div class="form-group">
                        <organization-selector placeholder="Search Organizations..."
                                               @ready="is_ready = true"
                                               @change="setOrganization($event)"/>
                    </div>
                </div>
            </template>

            <section>
                <div class="px-4 py-3">
                    <template v-if="organization">
                        <h6 class="mb-3">Found <span class="text-danger">{{ project_ids.length }}</span> projects in this organization.</h6>
                        <div v-for="id in project_ids">
                            <project-report :project-id="id" class="mb-3"></project-report>
                        </div>
                    </template>
                    <template v-else>
                        Search for an organization first.
                    </template>
                </div>
            </section>

        </app-content-pane>

    </admin-layout>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout";
import AppContentPane from "@/Components/AppContentPane";
import OrganizationSelector from "@/Components/Common/OrganizationSelector";
import ProjectReport from "@/Components/Report/ProjectReport";

export default {
    name: "OrganizationReport",
    components: {ProjectReport, OrganizationSelector, AppContentPane, AdminLayout},

    props: {
        report: Object,
    },

    data(){
        return {
            is_ready: false,
        }
    },

    computed: {
        organization(){
            return this.report?.organization ?? null;
        },
        project_ids(){
            return this.report?.project_ids ?? [];
        },

    },

    methods: {
        setOrganization(org){
            this.$inertia.visit(this.route('report.org', {organization: org.id, ...this.global_url_params}));
        }
    }
}
</script>

<style scoped>

</style>
